<template>
  <section class="hero">
    <div class="hero-background" :style="{ backgroundImage: `url(${$config.hero.background_image})` }"></div>
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title" v-html="$config.hero.title"></h1>
        <p class="hero-subtitle">{{ $config.hero.subtitle }}</p>
        <div class="hero-actions">
          <button class="btn btn-primary" @click="goToDownload">{{ $config.hero.download_button }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  methods: {
    goToDownload() {
      this.$router.push('/download');
    }
  }
};
</script>

<style scoped>
.hero {
  position: relative;
  padding: 240px 0 240px 0;
  text-align: left;
  color: #ffffff;
  min-height: 100vh - 80px;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.hero-content {
  max-width: 600px;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 1.2;
  color: rgba(14, 61, 69, 1);
  text-align: left;
  vertical-align: top;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 1.6;
  color: rgba(14, 61, 69, 1);
  text-align: left;
  vertical-align: top;
  margin-bottom: 32px;
}

.hero-actions {
  margin-top: 24px;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background-color: #0D3A4A;
  color: white;
}

.btn-primary:hover {
  background-color: #0a2d37;
  transform: translateY(-2px);
}


/* 移动端适配 */
@media (max-width: 768px) {
  .hero {
    padding: 120px 0 80px 0;
    /* text-align: center; */
    min-height: calc(100vh - 80px); /* 考虑header高度 */
  }
  
  .container {
    padding: 0 24px;
  }
  
  .hero-content {
    margin: 0 auto;
    max-width: 100%;
  }
  
  .hero-title {
    font-size: 36px;
    line-height: 1.3;
    margin-bottom: 24px;
  }
  
  .hero-subtitle {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .hero-actions {
    margin-top: 32px;
  }
  
}

</style>
